export default class Marquee extends HTMLElement {
  constructor() {
    super();

    // Bindings
    this.onResize = this.onResize.bind(this);

    // Selectors
    this._node = this;
    this._tracks = this._node.querySelectorAll('.track');
    this._base_item = this._tracks[0].querySelectorAll('.item')[0];
    this._base_item_html = this._base_item.innerHTML;
    this._prev_ww = 0;

    // Events
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  onResize() {
    let ww = window.innerWidth;

    if (ww !== this._prev_ww) {
      let first_track = this._node.querySelectorAll('.track')[0],
          first_item = first_track.querySelectorAll('.item')[0],
          first_item_width = first_item.getBoundingClientRect().width,
          items_count = Math.ceil(ww / first_item_width),
          items_html = '',
          track_html = '';

      if (items_count > 1) {
        [...Array(items_count)].forEach((n, i) => {
          items_html += `<div class="item">${ this._base_item_html }</div>`;
        });

        this._tracks.forEach((el, i) => {
          el.innerHTML = items_html;
        });
      }
    }

    this._prev_ww = ww;
  }

  disconnectedCallback() {
    window.addEventListener('resize', this.onResize);
  }
}
